import React, { useState, useEffect } from "react";
import {
  NavLink,
  useNavigate,
  useLocation,
  Link,
  useSearchParams,
} from "react-router-dom";
import { supabase } from "../../supabaseClient";
import { FaSearch, FaRegCommentDots } from "react-icons/fa";
import "./Sidebar.scss";

const Sidebar = ({ currentCategory }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [recentPosts, setRecentPosts] = useState([]);
  const [tags, setTags] = useState([]);
  const [tagsLoading, setTagsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation(); // Mevcut sayfanın URL'ini almak için

  const [searchParams] = useSearchParams();
  const activeTag = searchParams.get("etiket");

  // Son Yazıları Çekme
  useEffect(() => {
    const fetchRecentPosts = async () => {
      const { data, error } = await supabase
        .from("posts")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(4); // Son 4 yazıyı alalım

      if (error) {
        console.error("Error fetching recent posts:", error);
      } else {
        setRecentPosts(data);
      }
    };
    fetchRecentPosts();
  }, []);

  // Etiketleri Çekme
  useEffect(() => {
    const fetchTags = async () => {
      setTagsLoading(true);

      // Temel sorguyu oluştur
      let query = supabase.from("posts").select("tags");

      // EĞER BİR KATEGORİ BELİRTİLDİYSE, SADECE O KATEGORİNİN ETİKETLERİNİ ÇEK
      if (currentCategory) {
        query = query.eq("category", currentCategory);
      }

      // Sorguyu çalıştır
      const { data, error } = await query;

      if (error) {
        console.error("Error fetching tags:", error);
      } else {
        const allTags = data.flatMap((post) => post.tags || []);
        const uniqueTags = [...new Set(allTags)];
        setTags(uniqueTags);
      }
      setTagsLoading(false);
    };

    fetchTags();
  }, [currentCategory]);

  // Statik Kategoriler
  const categories = [
    { name: "Pati Hikayeleri", url: "/pati-hikayeleri" },
    { name: "Hekimlerimizden", url: "/hekimlerimizden" },
  ];

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/arama?q=${searchTerm.trim()}`);
      setSearchTerm("");
    }
  };

  return (
    <aside className="sidebar">
      {/* Arama Kutusu */}
      <form
        className="sidebar-widget search-widget"
        onSubmit={handleSearchSubmit}
      >
        <input
          type="text"
          placeholder="Ara"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button type="submit">
          <FaSearch />
        </button>
      </form>

      {/* Son Yazılar (Artık Dinamik) */}
      <div className="sidebar-widget recent-posts-widget">
        <h4 className="widget-title">Son Yazılar</h4>
        <div className="posts-list">
          {recentPosts.map((post) => (
            <Link
              to={`/${
                post.category === "Pati Hikayeleri"
                  ? "pati-hikayeleri"
                  : "hekimlerimizden"
              }/${post.slug}`}
              key={post.id}
              className="recent-post-item"
            >
              <img
                src={post.image_url}
                alt={post.title}
                className="post-image"
              />
              <div className="post-info">
                {/* Yorum sayısını şimdilik statik bırakabiliriz veya sonradan ekleyebiliriz */}
                <h5 className="post-title">{post.title}</h5>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Kategoriler (NavLink ile Aktif Olan Belli Olacak) */}
      <div className="sidebar-widget categories-widget">
        <h4 className="widget-title">Kategoriler</h4>
        <ul className="categories-list">
          {categories.map((cat, index) => (
            <li key={index}>
              <NavLink to={cat.url}>{cat.name}</NavLink>
            </li>
          ))}
        </ul>
      </div>

      {/* Etiketler (Artık Dinamik ve Filtreleme Linkli) */}
      {currentCategory && (
        <div className="sidebar-widget tags-widget">
          <h4 className="widget-title">Etiketler (#)</h4>
          <div className="tags-list">
            {tagsLoading ? (
              <p>Yükleniyor...</p>
            ) : tags.length > 0 ? (
              tags.map((tag, index) => (
                <Link
                  to={`${location.pathname}?etiket=${tag}`}
                  key={index}
                  className={`tag-item ${
                    activeTag === tag ? "active-tag" : ""
                  }`}
                >
                  #{tag}
                </Link>
              ))
            ) : (
              <p>Henüz etiket eklenmemiş.</p>
            )}
          </div>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;
